import { useStatusColor } from '../../../utilities/ColorUtilities';

export default function SiteMarker(props) {
    const { status, size } = props;

    const statusColor = useStatusColor(status.worst || 'gray');

    return (
        <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 42 42" aria-labelledby="site status" role="img">
            <circle cx="20" cy="20" r="16" fill="transparent" stroke={statusColor} strokeWidth="8" opacity={0.5} />
            <circle cx="20" cy="20" r="11" fill="transparent" stroke="white" strokeWidth="2" />
            <circle cx="20" cy="20" r="10" fill={statusColor} opacity={0.9} />
        </svg>
    );
}
